import { Component, OnInit, ViewChild,ElementRef} from '@angular/core';
import { MiniAppsService } from '../miniapps.service';
import { Router } from '@angular/router';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Component({
  selector: 'app-miniapps-list',
  templateUrl: './miniapps-list.component.html',
  styleUrls: ['./miniapps-list.component.css', '../miniapps.component.css'],
})
export class MiniAppssListComponent implements OnInit {
  @ViewChild('widgetsContent') widgetsContent: ElementRef;
  @ViewChild('widgetsContentItem') widgetsContentItem: ElementRef;

  merchantId: string;
  loginUserDetails: any;
  allMiniAppsDetails: any = [];
  allMiniAppsConfigurationDetails: Array<any> = [];
  allMiniAppssWebhookUrls:Array<any> = [];
  copyURLString: string;
  horizontalPosition: MatSnackBarHorizontalPosition= 'end';
  verticalPosition: MatSnackBarVerticalPosition= 'top';
  progressArray:Array<any>=[]
  apiKeyIsGenerated: boolean = false;
  tab: any;
  allMiniAppsShareableLinks: Array<string>=[];
  constructor(private miniappsService: MiniAppsService, private router: Router,private _snackBar: MatSnackBar) {
   
  }

  ngOnInit(): void {
    this.loginUserDetails = JSON.parse(
      localStorage.getItem('loginUserDetails')
    );
    this.merchantId = this.loginUserDetails.merchant_id;
    this.getAllMiniAppsDetails();
    if(localStorage.getItem('apiKey')) {
      this.apiKeyIsGenerated = true;
    }
  }

  onClick(check){
    if(check == 1){
      this.tab = 'tab1'
    }else if(check == 2){
      this.tab = 'tab2'
    }

  }
  

  getAllMiniAppsDetails() {

   this.miniappsService.getMiniAppsDetailsByMerchantId(this.merchantId).subscribe(
      (res) => {
        this.allMiniAppsDetails = res.body.data;
        this.getMiniAppsShareableLinks()

          // this.allMiniAppssWebhookUrls=responseList
        this.miniappsService.requestMultipleMiniAppsConfigurationById(this.allMiniAppsDetails)
          .subscribe((responseList) => {
            responseList.forEach((element) => {
              this.allMiniAppsConfigurationDetails.push(element.body);
              this.setMiniAppsProgress()
            });
        });
      },
      (error) => {}
    );
  }

  getLaunchUrls(){

  }
  goToEditMiniApps(id) {
    this.router.navigateByUrl('miniapps/edit/' + id);
  }

  setMiniAppsProgress(){
    let percentage = 0
    this.progressArray=[]
    this.allMiniAppsConfigurationDetails.forEach((element,index)=>{
      percentage = 25
      if(element.description&& element.photo && element.language_supported && element.language_supported.length > 0){
        percentage=percentage+25
        if((element.customer_support_email || element.customer_support_phone)){
          percentage=percentage+25
          if(element.launch_url){
            percentage=percentage+25
          }
        }
      }
      if(percentage != 100){
        this.progressArray.push(percentage)
      }
      
      this.allMiniAppsConfigurationDetails[index]["progress"]=percentage
    })
  
  }

  completeNow(miniappsid,progress){
    let stepNumber= 0

    switch(progress) {
      case 25:
        stepNumber= 1
        break;
      case 50:
        stepNumber= 2
        break;
      case 75:
        stepNumber= 3
        break;
      default:
        stepNumber= 0
    }
    this.router.navigateByUrl('miniapps/create-miniapps/'+miniappsid+'/'+stepNumber)
  }

  scrollLeft(){
    this.widgetsContent.nativeElement.scrollLeft -= (this.widgetsContentItem.nativeElement.clientWidth+40);
  }

  scrollRight(){
    this.widgetsContent.nativeElement.scrollLeft += (this.widgetsContentItem.nativeElement.clientWidth+40);
  }

goToLink(url: string){
  window.open(url, "_blank");
}

getMiniAppsShareableLinks(){
  this.miniappsService.requestMiniAppsShareableLinkById(this.allMiniAppsDetails)
  .subscribe((responseList) => {
    responseList.forEach((element) => {
      this.allMiniAppsShareableLinks.push(element.body.shareable_link);
    });
  });
}

}
